import { IPrcustomSignatureClientData } from '../features/customSignature/store/customSignature.types'
import { SignaturesConstants } from '../features/signatures/store/signatures.constants'
import { ISignaturesState } from '../features/signatures/store/signatures.types'

export const hasStandardSignatureUnsavedData = (signaturesState: ISignaturesState) => {
  const {
    witnessPrintedName,
    witnessAddress,
    witnessPhone,
    representativePrintedName,
    representativePhone,
    representativeAddress,
    receivingFacilityPrintedName,
    receivingFacilityRepTitle,
    sectionTwoReasonIncapableOfSigning,
    sectionThreeReasonIncapableOfSigning,
    crew,
    selectedSignatureType,
  } = signaturesState

  if (selectedSignatureType?.signatureType === SignaturesConstants.PATIENT && signaturesState.tempSignature) {
    return true
  } else if (
    selectedSignatureType?.signatureType === SignaturesConstants.WITNESS &&
    (signaturesState.tempSignature || witnessPrintedName || witnessAddress || witnessPhone)
  ) {
    return true
  } else if (selectedSignatureType?.signatureType === SignaturesConstants.AMBULANCE && signaturesState.tempSignature) {
    return true
  } else if (
    selectedSignatureType?.signatureType === SignaturesConstants.REPRESENTATIVE &&
    (signaturesState.tempSignature ||
      sectionTwoReasonIncapableOfSigning ||
      representativePrintedName ||
      representativePhone ||
      representativeAddress)
  ) {
    return true
  } else if (
    selectedSignatureType?.signatureType === SignaturesConstants.CREW &&
    (signaturesState.tempSignature || sectionThreeReasonIncapableOfSigning || crew)
  ) {
    return true
  } else if (
    selectedSignatureType?.signatureType === SignaturesConstants.RECEIVING &&
    (signaturesState.tempSignature ||
      sectionThreeReasonIncapableOfSigning ||
      receivingFacilityPrintedName ||
      receivingFacilityRepTitle)
  ) {
    return true
  } else return false
}

export const hasCustomSignatureUnsavedData = (customSignatureClientData: IPrcustomSignatureClientData) => {
  const { prFormsSignatureObj, tempSignature } = customSignatureClientData
  const { signingReason, signatoryName, signatoryRelation, signatoryPhone } = prFormsSignatureObj
  if (signingReason || signatoryName || signatoryRelation || signatoryPhone || tempSignature) {
    return true
  } else {
    return false
  }
}

const SIGNATURE_URL_FIELDS = [
  'patientSignature',
  'witnessSignature',
  'ambulanceCrewSignature',
  'representativeSignature',
  'receivingFacilitySignature',
  'crewSignature',
] as const

export const revokeAllSignatureUrls = (signaturesState: ISignaturesState): void => {
  SIGNATURE_URL_FIELDS.forEach((field) => {
    const url = signaturesState[field]
    if (url) URL.revokeObjectURL(url)
  })
}

export const trimSignatureDataUrl = (signaturePad: any): string | null => {
  const canvas: HTMLCanvasElement | null = signaturePad?.getCanvas?.()
  if (!canvas) return null

  const ctx = canvas.getContext('2d')
  if (!ctx) return null

  const { width, height } = canvas
  const imageData = ctx.getImageData(0, 0, width, height)
  const data = imageData.data

  let top = height
  let left = width
  let right = 0
  let bottom = 0
  let found = false

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      const alpha = data[(y * width + x) * 4 + 3]
      if (alpha > 0) {
        found = true
        if (x < left) left = x
        if (x > right) right = x
        if (y < top) top = y
        if (y > bottom) bottom = y
      }
    }
  }

  if (!found) return null

  const pad = 6
  left = Math.max(0, left - pad)
  top = Math.max(0, top - pad)
  right = Math.min(width - 1, right + pad)
  bottom = Math.min(height - 1, bottom + pad)

  const trimmedWidth = right - left + 1
  const trimmedHeight = bottom - top + 1

  const trimmedCanvas = document.createElement('canvas')
  trimmedCanvas.width = trimmedWidth
  trimmedCanvas.height = trimmedHeight

  const trimmedCtx = trimmedCanvas.getContext('2d')
  if (!trimmedCtx) return null

  const sourceCanvas = canvas as unknown as CanvasImageSource
  trimmedCtx.drawImage(sourceCanvas, left, top, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight)

  return trimmedCanvas.toDataURL('image/png')
}
